import { render, staticRenderFns } from "./AgreementNotificationView.vue?vue&type=template&id=efe1e012&"
import script from "./AgreementNotificationView.vue?vue&type=script&lang=js&"
export * from "./AgreementNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports